import gql from "graphql-tag";

const GET_SPEND_DATA = gql`
    query(
        $client: uuid = "2cfb47a8-a4c8-43c8-909c-396ace5a38e4"
        $limit: Int = 9999999
        $offset: Int = 0
    ) {
        spendmd_db_spend_data_new_aggregate(
            where: {
                client_id: {_eq: $client}
                total_spend: {_gt: 0}
                secondary_category_id: {_eq: 580}
                status_id: {_neq: 2}
            }
            limit: $limit
            offset: $offset
            order_by: {total_spend: desc}) {
                nodes {
                    id
                    vendor_source
                    spend_type
                    vendor_catalog
                    item_description
                    prime_category_name
                    secondary_category_name
                    sub_category_name
                    total_spend
                }
                aggregate {
                    count
                }
        }
    }
`;

const INSERT_SPEND_DATA = gql`
    mutation(
        $apbatch_no: String!
        $comp_code: String!
        $cp_loc_code: String!
        $doc_date: date!
        $doc_status: Int!
        $ext_doc_no: String!
        $inv_no: String!
        $net_amount: money
        $pay_type_code: String!
        $processed_date: date!
        $remit_to_name: String!
    ) {
        insert_spendmd_db_spend_data(
            objects: {
                apbatch_no: $apbatch_no
                comp_code: $comp_code
                cp_loc_code: $cp_loc_code
                doc_date: $doc_date
                doc_status: $doc_status
                ext_doc_no: $ext_doc_no
                inv_no: $inv_no
                net_amount: $net_amount
                pay_type_code: $pay_type_code
                processed_date: $processed_date
                remit_to_name: $remit_to_name
            }
        ) {
            returning {
                id
            }
        }
    }
`;

export default {
    GET_SPEND_DATA,
    INSERT_SPEND_DATA
};
